// Imports
import Alpine from 'alpinejs';
import Header from "@js/modules/Header";

// Project imports
import PageScrolling from '@js/modules/PageScrolling';

class Navigation {
    constructor() {
        const nav = document.getElementById('nav');

        if (!nav) {
            Alpine.store('nav', {
                isOpen: false,
                subOpen: null,
                toggle() {},
                open() {},
                close() {
                    this.isOpen = false;
                    this.subOpen = null;
                },
            });
            return;
        }

        // Set up Alpine store to control nav toggle
        Alpine.store('nav', {
            isOpen: false,
            subOpen: null,
            nav,
            navItems: nav.querySelectorAll('.appear-item'),

            toggle() {
                if (this.isOpen) {
                    this.close();
                }
                else {
                    this.open();
                }
            },
            open() {
                // Open nav
                this.isOpen = true;

                // Disable scroll
                if (!document.documentElement.classList.contains('ios') && window.innerWidth < 1024) {
                    console.log('Lock nav');
                    PageScrolling.lock(this.nav);
                }

                function getRemainingHeight(element) {
                    if (!element) return 0;

                    const elementHeight = element.offsetHeight;
                    const scrolled = window.scrollY;

                    return Math.max(0, elementHeight - scrolled);
                }

                const hdr = document.querySelector('.mn-hdr');
                const hdrNavEls = hdr.querySelector('.mn-hdr-bar-els');
                const targetElement = document.querySelector('.jdl-btn, .jdl-rentals-btn');

                if (hdr.hasAttribute('style')) {
                    const hdrStyleValue = hdr.getAttribute('style');
                    hdr.setAttribute('data-style', hdrStyleValue);
                }

                // Update header element
                hdr.style.position = 'fixed';
                if (window.innerWidth < 1024) {
                    const remainingHeight = getRemainingHeight(targetElement);
                    document.documentElement.style.setProperty('--jdlBtn', `${remainingHeight}px`);
                    hdr.style.top = `${remainingHeight}px`;
                }
                hdrNavEls.classList.add(hdr.getAttribute('data-nav-open-theme'), 'text-theme');

                setTimeout(() => {
                    // Animate nav items
                    this.navItems.forEach((item, index) => {
                        item.style.transitionDelay = `${index * 0.056}s`;
                        item.classList.add('_visible');
                    });
                }, 300);
            },
            close() {
                // Close nav
                this.isOpen = false;
                // Close sub nav
                this.subOpen = null;

                // Enable scroll
                PageScrolling.unlock(this.nav);

                // Update header element
                const hdr = document.querySelector('.mn-hdr');
                const hdrNavEls = hdr.querySelector('.mn-hdr-bar-els');
                hdr.removeAttribute('style');

                hdrNavEls.classList.forEach(className => {
                    if (/^theme\d+$/.test(className)) {
                        hdr.classList.remove(className);
                    }
                });
                hdrNavEls.classList.remove('bg-theme', 'text-theme');

                hdr.setAttribute('style', hdr.getAttribute('data-style'));

                // Animate nav items
                this.navItems.forEach((item) => {
                    item.classList.remove('_visible');
                    item.style.transitionDelay = '';
                });
            }
        });

        // Handle resize
        window.addEventListener('resize', () => {
            Alpine.store('nav').close();
        });
    }
}

export default new Navigation();
